import apiClient from './apiClient'

export const ACCESS_KEY = 'portal-access-key'
export const STUDENT_ACCESS_KEY = 'student-portal-access-key'
export const SCHOOL_ACCESS_KEY = 'school-portal-access-key'

export const getInstitutionInternshipRequestPortal = (institutionUuid, portalAccessKey, isStudentPortal) => apiClient.get(
  null,
  `public/internship-request-portal/institution/${institutionUuid}`,
  { [isStudentPortal ? STUDENT_ACCESS_KEY : SCHOOL_ACCESS_KEY]: portalAccessKey }
)

export const getInstitutionGroupInternshipRequestPortal = (institutionGroupUuid, portalAccessKey, isStudentPortal) => apiClient.get(
  null,
  `public/internship-request-portal/institution-group/${institutionGroupUuid}`,
  { [isStudentPortal ? STUDENT_ACCESS_KEY : SCHOOL_ACCESS_KEY]: portalAccessKey }
)
